import { useEffect } from 'react';

import { startUpdateActivityReporter } from '@/lib/update-activity';

export function useUpdateActivityReporter(): void {
  useEffect(() => startUpdateActivityReporter(), []);
}
